import { ProductTagsConfig } from 'shared/components/Product/components/Tag/Tag';

export interface IProductProps {
  item: Listing.IProduct;
  className?: string;
  onInteraction?: VoidFunction;
  //imagechildren for icons on image(wishlist and close icon)
  ImageChildren?: React.ReactNode;
  showPrice?: boolean;
  //descriptionChildren for price reveal and other offers
  DescriptionChildren?: React.ReactNode;
  isImageLazy?: boolean;
  containsResponsible?: boolean;
  trackingMetadata?: Record<string, any>;
  ProductStamp?: React.ReactNode;
  hideSoldOut?: boolean;
  productTagsConfig?: ProductTagsConfig;
}

export enum CAROUSEL_STATES {
  AUTOPLAY,
  FOCUS,
  SILENT,
}
